<lib-loading
  class="page-loader"
  [isLoading]="isLoading"
  *ngIf="isLoading"
></lib-loading>
<router-outlet></router-outlet>
